import { billingAmountAction } from "../actions/billingAmountAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedBillingAmount: null,
};

const billingAmountSlice = createSlice({
  name: "billingAmount",
  initialState: initialState,
  reducers: billingAmountAction,
});

export const { selectBillingAmount } = billingAmountSlice.actions;

export default billingAmountSlice.reducer;
